import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "facet-values-checkbox-item__count" }

import { computed } from 'vue';
import {
  FacetHit,
  FacetValue,
  getContext,
} from '@/composables/useDynamicProductListing';
import useSizeDisplay from '@/composables/useSizeDisplay';


export default /*#__PURE__*/_defineComponent({
  __name: 'FacetValuesCheckboxItem',
  props: {
    facet: null,
    value: null
  },
  setup(__props: any) {

const props = __props as {
  facet: FacetHit;
  value: FacetValue;
}



const { activeFacets, toggleFacetValue } = getContext();
const { getSizeName } = useSizeDisplay();

const isActive = computed(() => {
  return activeFacets
    .find((r) => r.id === props.facet.id)
    ?.values.find((r: any) => r.value === props.value.value);
});

function toggle() {
  toggleFacetValue(props.facet, props.value);
}

const displayValue = computed(() => {
  return props.facet.id === 'Size'
    ? getSizeName(props.value.label)
    : props.value.label;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", null, [
    _createElementVNode("a", {
      href: "#",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (toggle()), ["prevent"])),
      class: _normalizeClass(["facet-values-checkbox-item", {
        'facet-values-checkbox-item--active': _unref(isActive),
        'facet-values-checkbox-item--disabled': __props.value.count <= 0,
      }])
    }, [
      _createElementVNode("span", null, _toDisplayString(_unref(displayValue)), 1),
      _createElementVNode("span", _hoisted_1, "(" + _toDisplayString(__props.value.count) + ")", 1)
    ], 2)
  ]))
}
}

})